import { Grid } from "@mui/material";
import MxFormL3InputField from "@rf-l3/form/MxFormL3InputField";
import React, { memo } from "react";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import YoutubeIcon from "@icons-rf/videos/youtube.svg?react";
import DropboxIcon from "@icons-rf/videos/dropbox.svg?react";
import DriveIcon from "@icons-rf/videos/google-drive.svg?react";
const LinksFormSections = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <MxFormL3InputField
          name={`${CPropertyFormKeys.videos_property}.0`}
          label="Videos #1"
          withreacthookform={1}
          starticon={<YoutubeIcon width={20} height={20} />}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <MxFormL3InputField
          name={`${CPropertyFormKeys.videos_property}.1`}
          label="Videos #2"
          withreacthookform={1}
          starticon={<YoutubeIcon width={20} height={20} />}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <MxFormL3InputField
          name={`${CPropertyFormKeys.videos_property}.2`}
          label="Videos #3"
          withreacthookform={1}
          starticon={<YoutubeIcon width={20} height={20} />}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <MxFormL3InputField
          name={CPropertyFormKeys.dropbox_link_property}
          label="Dropbox"
          withreacthookform={1}
          starticon={<DropboxIcon width={20} height={20} />}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <MxFormL3InputField
          name={CPropertyFormKeys.drive_link_property}
          label="Google Drive"
          withreacthookform={1}
          starticon={<DriveIcon width={20} height={20} />}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <MxFormL3InputField
          name={CPropertyFormKeys.tour_virtual_property}
          label="Tour Virtual"
          withreacthookform={1}
        />
      </Grid>
    </Grid>
  );
};

export default memo(LinksFormSections);
